export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "add_to_my_album": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add to my album"])}
      },
      "de": {
        "add_to_my_album": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zu meinem Album hinzufügen"])}
      }
    }
  })
}
